
import * as React from 'react'
import { Image, Text, View, TouchableOpacity, ScrollView, ActivityIndicator } from 'react-native'
import images from '../../assets/images'
import { useTheme } from '@react-navigation/native'
import moment from 'moment'
import AnimatedProgressWheel from 'react-native-progress-wheel'
import AnimatedNumber from 'react-native-animated-number'
import Axios from 'axios'
import { RefreshControl } from 'react-native-web-refresh-control'

export default React.memo(function FinanceIndex({ month_string }) {
    const { colors } = useTheme()
    const [data, setData] = React.useState()
    const [refreshing, setRefreshing] = React.useState(true)

    React.useEffect(() => {
        setRefreshing(true)
        Axios.get(`/api/ceo/finace/financial_indicators?thang=${month_string}`)
            .then(res => {
                console.log(res)
                if (res.status === 200)
                    setData(res.data.data)
                setRefreshing(false)
            }).catch(err => {
                setRefreshing(false)
                console.log(err)
            })
    }, [month_string])

    const getColorProgress = (value) => {
        try {
            if (value < 50) return colors.process_3
            else if (value < 75) return colors.process_1
            else return colors.process_2
        } catch (error) {
        }
    }

    const getColorText = (value) => {
        try {
            if (value < 50) return colors.text_red
            else if (value < 75) return colors.text_yellow
            else return colors.text_green
        } catch (error) {
        }
    }

    const onRefresh = () => {
        setRefreshing(true)
        Axios.get(`/api/ceo/finace/financial_indicators?thang=${month_string}`)
            .then(res => {
                console.log(res)
                if (res.status === 200) {
                    setData(res.data.data)
                }
                setRefreshing(false)
            }).catch(err => {
                setRefreshing(false)
                console.log(err)
            })
    }

    return (
        <ScrollView style={{ flex: 1 }} refreshControl={<RefreshControl refreshing={refreshing} onRefresh={onRefresh} tintColor={colors.text} colors={[colors.text]} />}>
            {
                data ? <>
                    <View style={{ backgroundColor: 'white', marginHorizontal: 12, marginTop: 18, borderRadius: 10, paddingHorizontal: 15 }}>
                        <View style={{ marginTop: 8, flexDirection: 'column' }}>
                            <Text style={{ fontFamily: 'Nunito_700Bold', fontSize: 15, color: colors.text, textAlign: 'center' }}>ROS</Text>
                            <Text style={{ fontFamily: 'Nunito_700Bold', fontSize: 32, color: colors.text, textAlign: 'center' }}>{Math.round(data?.ros * 100) / 100}%</Text>
                        </View>
                        <View style={{ flexDirection: 'row', marginBottom: 16, marginTop: 12 }}>
                            <View style={{
                                height: 28, position: 'relative', flex: 1, backgroundColor: colors.process_background, borderRadius: 3,
                                justifyContent: 'center'
                            }}>
                                <View style={{
                                    position: 'absolute', top: 0, left: 0, width: `${data?.ros_compare_plan > 100 ? 100 : data?.ros_compare_plan}%`,
                                    height: '100%', backgroundColor: getColorProgress(data?.ros_compare_plan), borderRadius: 3
                                }} />
                                <View style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', justifyContent: 'center' }}>
                                    <Text style={{ color: colors.text, fontFamily: 'Nunito_700Bold', paddingHorizontal: 6 }}>{Math.round(data?.ros_compare_plan * 100) / 100}% kế hoạch</Text>
                                </View>
                            </View>
                        </View>
                    </View>

                    <View style={{ backgroundColor: 'white', marginHorizontal: 12, marginTop: 18, borderRadius: 10, paddingHorizontal: 15, paddingBottom: 12 }}>
                        <View style={{ marginTop: 8, flexDirection: 'row' }}>
                            <View style={{ flex: 1, flexDirection: 'column' }}>
                                <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                                    <View style={{ width: 10, height: 10, borderRadius: 5, backgroundColor: '#96C0FF' }} />
                                    <Text style={{ fontFamily: 'Nunito_700Bold', color: colors.text, fontSize: 12, marginLeft: 8, color: '#8F99BA' }}>so với kế hoạch</Text>
                                </View>
                                <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                                    <View style={{ width: 10, height: 10, borderRadius: 5, backgroundColor: '#FFBD86' }} />
                                    <Text style={{ fontFamily: 'Nunito_700Bold', color: colors.text, fontSize: 12, marginLeft: 8, color: '#8F99BA' }}>so với tháng trước</Text>
                                </View>
                            </View>
                            <View>
                                <Text style={{ fontFamily: 'Nunito_700Bold', color: colors.text, fontSize: 12, marginLeft: 5, color: '#8F99BA' }}>đơn vị: triệu đồng</Text>
                            </View>
                        </View>
                        <View style={{ flexDirection: 'column', marginTop: 22 }}>
                            <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
                                <Text style={{ color: '#8F99BA', fontFamily: 'Nunito_700Bold' }}>Doanh thu</Text>
                                <Text style={{ color: colors.text, fontFamily: 'Nunito_700Bold', fontSize: 18 }}>{data?.revenue?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</Text>
                            </View>
                            <View style={{ flexDirection: 'row', marginTop: 5, alignItems: 'center' }}>
                                <View style={{
                                    height: 10, position: 'relative', flex: 1, backgroundColor: colors.process_background, borderRadius: 3,
                                    justifyContent: 'center'
                                }}>
                                    <View style={{
                                        position: 'absolute', top: 0, left: 0, width: `${data?.revenue_compare_plan > 100 ? 100 : data?.revenue_compare_plan}%`,
                                        height: '100%', backgroundColor: '#96C0FF', borderRadius: 3
                                    }} />
                                </View>
                                <Text style={{ color: '#8F99BA', fontFamily: 'Nunito_700Bold', width: 60, textAlign: 'right' }}>{Math.round(data?.revenue_compare_plan * 100) / 100}%</Text>
                            </View>
                            <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                                <View style={{
                                    height: 10, position: 'relative', flex: 1, backgroundColor: colors.process_background, borderRadius: 3,
                                    justifyContent: 'center'
                                }}>
                                    <View style={{
                                        position: 'absolute', top: 0, left: 0, width: `${data?.revenue_compare_last_month > 100 ? 100 : data?.revenue_compare_last_month}%`,
                                        height: '100%', backgroundColor: '#FFBD86', borderRadius: 3
                                    }} />
                                </View>
                                <Text style={{ color: '#8F99BA', fontFamily: 'Nunito_700Bold', width: 60, textAlign: 'right' }}>{Math.round(data?.revenue_compare_last_month * 100) / 100}%</Text>
                            </View>
                        </View>

                        <View style={{ flexDirection: 'column', marginTop: 16 }}>
                            <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
                                <Text style={{ color: '#8F99BA', fontFamily: 'Nunito_700Bold' }}>Giá vốn</Text>
                                <Text style={{ color: colors.text, fontFamily: 'Nunito_700Bold', fontSize: 18 }}>{data?.cost_price?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</Text>
                            </View>
                            <View style={{ flexDirection: 'row', marginTop: 5, alignItems: 'center' }}>
                                <View style={{
                                    height: 10, position: 'relative', flex: 1, backgroundColor: colors.process_background, borderRadius: 3,
                                    justifyContent: 'center'
                                }}>
                                    <View style={{
                                        position: 'absolute', top: 0, left: 0, width: `${data?.cost_price_compare_plan > 100 ? 100 : data?.cost_price_compare_plan}%`,
                                        height: '100%', backgroundColor: '#96C0FF', borderRadius: 3
                                    }} />
                                </View>
                                <Text style={{ color: '#8F99BA', fontFamily: 'Nunito_700Bold', width: 60, textAlign: 'right' }}>{Math.round(data?.cost_price_compare_plan * 100) / 100}%</Text>
                            </View>
                            <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                                <View style={{
                                    height: 10, position: 'relative', flex: 1, backgroundColor: colors.process_background, borderRadius: 3,
                                    justifyContent: 'center'
                                }}>
                                    <View style={{
                                        position: 'absolute', top: 0, left: 0, width: `${data?.cost_price_compare_last_month > 100 ? 100 : data?.cost_price_compare_last_month}%`,
                                        height: '100%', backgroundColor: '#FFBD86', borderRadius: 3
                                    }} />
                                </View>
                                <Text style={{ color: '#8F99BA', fontFamily: 'Nunito_700Bold', width: 60, textAlign: 'right' }}>{Math.round(data?.cost_price_compare_last_month * 100) / 100}%</Text>
                            </View>
                        </View>

                        <View style={{ flexDirection: 'column', marginTop: 16 }}>
                            <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
                                <Text style={{ color: '#8F99BA', fontFamily: 'Nunito_700Bold' }}>Lợi nhuận gộp</Text>
                                <Text style={{ color: colors.text, fontFamily: 'Nunito_700Bold', fontSize: 18 }}>{data?.gross_profit?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</Text>
                            </View>
                            <View style={{ flexDirection: 'row', marginTop: 5, alignItems: 'center' }}>
                                <View style={{
                                    height: 10, position: 'relative', flex: 1, backgroundColor: colors.process_background, borderRadius: 3,
                                    justifyContent: 'center'
                                }}>
                                    <View style={{
                                        position: 'absolute', top: 0, left: 0, width: `${data?.gross_profit_compare_plan > 100 ? 100 : data?.gross_profit_compare_plan}%`,
                                        height: '100%', backgroundColor: '#96C0FF', borderRadius: 3
                                    }} />
                                </View>
                                <Text style={{ color: '#8F99BA', fontFamily: 'Nunito_700Bold', width: 60, textAlign: 'right' }}>{Math.round(data?.gross_profit_compare_plan * 100) / 100}%</Text>
                            </View>
                            <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                                <View style={{
                                    height: 10, position: 'relative', flex: 1, backgroundColor: colors.process_background, borderRadius: 3,
                                    justifyContent: 'center'
                                }}>
                                    <View style={{
                                        position: 'absolute', top: 0, left: 0, width: `${data?.gross_profit_compare_last_month > 100 ? 100 : data?.gross_profit_compare_last_month}%`,
                                        height: '100%', backgroundColor: '#FFBD86', borderRadius: 3
                                    }} />
                                </View>
                                <Text style={{ color: '#8F99BA', fontFamily: 'Nunito_700Bold', width: 60, textAlign: 'right' }}>{Math.round(data?.gross_profit_compare_last_month * 100) / 100}%</Text>
                            </View>
                        </View>

                        <View style={{ flexDirection: 'column', marginTop: 16 }}>
                            <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
                                <Text style={{ color: '#8F99BA', fontFamily: 'Nunito_700Bold' }}>Chi phí khác</Text>
                                <Text style={{ color: colors.text, fontFamily: 'Nunito_700Bold', fontSize: 18 }}>{data?.other_expenses?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</Text>
                            </View>
                            <View style={{ flexDirection: 'row', marginTop: 5, alignItems: 'center' }}>
                                <View style={{
                                    height: 10, position: 'relative', flex: 1, backgroundColor: colors.process_background, borderRadius: 3,
                                    justifyContent: 'center'
                                }}>
                                    <View style={{
                                        position: 'absolute', top: 0, left: 0, width: `${data?.other_expenses_compare_plan > 100 ? 100 : data?.other_expenses_compare_plan}%`,
                                        height: '100%', backgroundColor: '#96C0FF', borderRadius: 3
                                    }} />
                                </View>
                                <Text style={{ color: '#8F99BA', fontFamily: 'Nunito_700Bold', width: 60, textAlign: 'right' }}>{Math.round(data?.other_expenses_compare_plan * 100) / 100}%</Text>
                            </View>
                            <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                                <View style={{
                                    height: 10, position: 'relative', flex: 1, backgroundColor: colors.process_background, borderRadius: 3,
                                    justifyContent: 'center'
                                }}>
                                    <View style={{
                                        position: 'absolute', top: 0, left: 0, width: `${data?.extraordinary_income_compare_last_month > 100 ? 100 : data?.extraordinary_income_compare_last_month}%`,
                                        height: '100%', backgroundColor: '#FFBD86', borderRadius: 3
                                    }} />
                                </View>
                                <Text style={{ color: '#8F99BA', fontFamily: 'Nunito_700Bold', width: 60, textAlign: 'right' }}>{Math.round(data?.extraordinary_income_compare_last_month * 100) / 100}%</Text>
                            </View>
                        </View>

                        <View style={{ flexDirection: 'column', marginTop: 16 }}>
                            <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
                                <Text style={{ color: '#8F99BA', fontFamily: 'Nunito_700Bold' }}>Lợi nhuận thuần</Text>
                                <Text style={{ color: colors.text, fontFamily: 'Nunito_700Bold', fontSize: 18 }}>{data?.net_profit?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</Text>
                            </View>
                            <View style={{ flexDirection: 'row', marginTop: 5, alignItems: 'center' }}>
                                <View style={{
                                    height: 10, position: 'relative', flex: 1, backgroundColor: colors.process_background, borderRadius: 3,
                                    justifyContent: 'center'
                                }}>
                                    <View style={{
                                        position: 'absolute', top: 0, left: 0, width: `${data?.net_profit_compare_plan > 100 ? 100 : data?.net_profit_compare_plan}%`,
                                        height: '100%', backgroundColor: '#96C0FF', borderRadius: 3
                                    }} />
                                </View>
                                <Text style={{ color: '#8F99BA', fontFamily: 'Nunito_700Bold', width: 60, textAlign: 'right' }}>{Math.round(data?.net_profit_compare_plan * 100) / 100}%</Text>
                            </View>
                            <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                                <View style={{
                                    height: 10, position: 'relative', flex: 1, backgroundColor: colors.process_background, borderRadius: 3,
                                    justifyContent: 'center'
                                }}>
                                    <View style={{
                                        position: 'absolute', top: 0, left: 0, width: `${data?.net_profit_compare_last_month > 100 ? 100 : data?.net_profit_compare_last_month}%`,
                                        height: '100%', backgroundColor: '#FFBD86', borderRadius: 3
                                    }} />
                                </View>
                                <Text style={{ color: '#8F99BA', fontFamily: 'Nunito_700Bold', width: 60, textAlign: 'right' }}>{Math.round(data?.net_profit_compare_last_month * 100) / 100}%</Text>
                            </View>
                        </View>

                        <View style={{ flexDirection: 'column', marginTop: 16 }}>
                            <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
                                <Text style={{ color: '#8F99BA', fontFamily: 'Nunito_700Bold' }}>Lãi/lỗ hđ khác</Text>
                                <Text style={{ color: colors.text, fontFamily: 'Nunito_700Bold', fontSize: 18 }}>{data?.extraordinary_income?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</Text>
                            </View>
                            <View style={{ flexDirection: 'row', marginTop: 5, alignItems: 'center' }}>
                                <View style={{
                                    height: 10, position: 'relative', flex: 1, backgroundColor: colors.process_background, borderRadius: 3,
                                    justifyContent: 'center'
                                }}>
                                    <View style={{
                                        position: 'absolute', top: 0, left: 0, width: `${data?.extraordinary_income_compare_plan > 100 ? 100 : data?.extraordinary_income_compare_plan}%`,
                                        height: '100%', backgroundColor: '#96C0FF', borderRadius: 3
                                    }} />
                                </View>
                                <Text style={{ color: '#8F99BA', fontFamily: 'Nunito_700Bold', width: 60, textAlign: 'right' }}>{Math.round(data?.extraordinary_income_compare_plan * 100) / 100}%</Text>
                            </View>
                            <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                                <View style={{
                                    height: 10, position: 'relative', flex: 1, backgroundColor: colors.process_background, borderRadius: 3,
                                    justifyContent: 'center'
                                }}>
                                    <View style={{
                                        position: 'absolute', top: 0, left: 0, width: `${data?.extraordinary_income_compare_last_month > 100 ? 100 : data?.extraordinary_income_compare_last_month}%`,
                                        height: '100%', backgroundColor: '#FFBD86', borderRadius: 3
                                    }} />
                                </View>
                                <Text style={{ color: '#8F99BA', fontFamily: 'Nunito_700Bold', width: 60, textAlign: 'right' }}>{Math.round(data?.extraordinary_income_compare_last_month * 100) / 100}%</Text>
                            </View>
                        </View>

                        <View style={{ flexDirection: 'column', marginTop: 16 }}>
                            <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
                                <Text style={{ color: '#8F99BA', fontFamily: 'Nunito_700Bold' }}>L.Nhuận trước thuế</Text>
                                <Text style={{ color: colors.text, fontFamily: 'Nunito_700Bold', fontSize: 18 }}>{data?.ebit?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</Text>
                            </View>
                            <View style={{ flexDirection: 'row', marginTop: 5, alignItems: 'center' }}>
                                <View style={{
                                    height: 10, position: 'relative', flex: 1, backgroundColor: colors.process_background, borderRadius: 3,
                                    justifyContent: 'center'
                                }}>
                                    <View style={{
                                        position: 'absolute', top: 0, left: 0, width: `${data?.ebit_compare_plan > 100 ? 100 : data?.ebit_compare_plan}%`,
                                        height: '100%', backgroundColor: '#96C0FF', borderRadius: 3
                                    }} />
                                </View>
                                <Text style={{ color: '#8F99BA', fontFamily: 'Nunito_700Bold', width: 60, textAlign: 'right' }}>{Math.round(data?.ebit_compare_plan * 100) / 100}%</Text>
                            </View>
                            <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                                <View style={{
                                    height: 10, position: 'relative', flex: 1, backgroundColor: colors.process_background, borderRadius: 3,
                                    justifyContent: 'center'
                                }}>
                                    <View style={{
                                        position: 'absolute', top: 0, left: 0, width: `${data?.ebit_compare_last_month > 100 ? 100 : data?.ebit_compare_last_month}%`,
                                        height: '100%', backgroundColor: '#FFBD86', borderRadius: 3
                                    }} />
                                </View>
                                <Text style={{ color: '#8F99BA', fontFamily: 'Nunito_700Bold', width: 60, textAlign: 'right' }}>{Math.round(data?.ebit_compare_last_month * 100) / 100}%</Text>
                            </View>
                        </View>
                    </View>
                    <View style={{ marginBottom: 16 }} />
                </> : (
                        !refreshing ? <View style={{ marginTop: 80, flexDirection: 'column', alignItems: 'center' }}>
                            <Image source={images.server_error} style={{ width: 200, height: 200 }} />
                            <Text style={{ color: colors.text, fontFamily: 'Nunito_700Bold', marginTop: 24, fontSize: 18 }}>Đã có lỗi xảy ra</Text>
                            <Text style={{ color: colors.text, fontFamily: 'Nunito_700Bold', fontSize: 18 }}>Vui lòng ấn nút bên dưới để thử lại</Text>
                            <TouchableOpacity onPress={onRefresh}>
                                <Image source={images.refresh} style={{ width: 40, height: 40, marginTop: 16 }} />
                            </TouchableOpacity>
                        </View> : null
                    )
            }
        </ScrollView>
    );
})